import { InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CustomInputLabel from "../customInputLabel";

function TextInput({
  placeholder,
  name,
  value,
  onChange,
  InputStartIcon,
  type,
  InputEndIcon,
  id,
  fullWidth,
  multiline,
  rows,
  disabled,
  borderRadius,
  readonly,
  showPassIcon,
  handleClickEndIcon,
  inputBgColor,
  borderColor,
  label,
  noBorder = false,
  sx = {},
}) {
  const [showPass, setShowPass] = useState(false);

  return (
    <>
      {label && <CustomInputLabel label={label} />}
      <TextField
        id={id}
        type={type === "password" && showPass ? "text" : type}
        variant="outlined"
        size="small"
        fullWidth={fullWidth ?? true}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        multiline={multiline ?? false}
        rows={rows}
        disabled={disabled ?? false}
        onWheel={(e) => e.target.blur()}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: borderRadius || "8px",
            fontFamily: "Poppins",
            padding: "0px",
            px: "10px",
            background: inputBgColor || "none",
            borderColor: borderColor || "#225B27",
            "& fieldset": {
              border: noBorder ? "none" : "1px solid #225B27", // ✅ Default border ##225B27, removed if noBorder=true
            },
            "&:hover fieldset": {
              border: noBorder ? "none" : "1px solid #225B27", // ✅ Slightly darker on hover if border enabled
            },
            "&.Mui-focused fieldset": {
              border: noBorder ? "none" : "1px solid #225B27", // ✅ Focus border
            },
          },
          ...sx, // 🟢 Merge custom styles
        }}
        InputProps={{
          readOnly: readonly ?? false,
          startAdornment: InputStartIcon && (
            <InputAdornment position="start">{InputStartIcon}</InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (showPassIcon) {
                  setShowPass(!showPass);
                } else {
                  handleClickEndIcon && handleClickEndIcon();
                }
              }}
            >
              {showPassIcon ? (
                showPass ? <VisibilityIcon /> : <VisibilityOffIcon />
              ) : (
                InputEndIcon
              )}
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}

export default TextInput;
